import { useCallback, useMemo } from 'react'

import { useQuery } from '@shared/modules/use-query/hooks'
import { UseQueryOptions } from '@shared/modules/use-query/types'

import { ProductsService } from '../services'
import { Product } from '../types'
import { localURLMaker } from '@shared/utils/url-maker'
import { useBackgroundNavigate } from '@shared/hooks/use-background-navigate'
import { message } from 'antd'

export const useProductDetails = (id?: string | number) => {
  const navigate = useBackgroundNavigate()

  const queryData = useQuery<Product>(
    useCallback(async () => {
      const result = await ProductsService.getOneById(id as string)

      if (result.status === 200) {
        return result.data
      } else {
        throw new Error(result.data)
      }
    }, [id]),
    useMemo<UseQueryOptions>(
      () => ({
        initialData: null,
        enabled: !!id,
      }),
      [id],
    ),
  )

  const edit = useCallback(() => {
    if (!id) {
      message.error('Məhsul kodu mövcud deyil')
      return
    }
    navigate(localURLMaker('/products/:id/update', { id }), { withBackground: true })
  }, [navigate, id])

  return { ...queryData, edit }
}
